module.exports = __webpack_public_path__ + "img/whathot_big04_words.86d06b52.jpg";